import React from "react";
const ArrowBackIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={7}
      height={13}
      viewBox="0 0 7 13"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <path
        d="M1.839 6.425l4.586-4.586V.425l-6 6 6 6V11.01z"
        fillRule="nonzero"
      />
    </svg>
  )
);
ArrowBackIcon.displayName = "ArrowBackIcon";
export default ArrowBackIcon;
